import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LayoutComponent} from './layout.component';
import {DashboardsComponent} from '@app/modules/dashboards/dashboards.component';
import {AuthGuard} from '@app/shared';
import {MedicineComponent} from '@app/pages/medicine/medicine.component';
import {VendorComponent} from '@app/pages/vendor/vendor.component';
import {CustomerComponent} from '@app/pages/customer/customer.component';
import {PurchaseOrderModule} from '@app/modules/purchase-order/purchase-order.module';
import {PurchaseModule} from '@app/modules/purchase/purchase.module';
import {SaleModule} from '@app/modules/sale/sale.module';
import {PricingPlanComponent} from '@app/pages/pricing-plan/pricing-plan.component';
import {NotesComponent} from '@app/pages/notes/notes.component';
import {ReportModule} from '@app/modules/report/report.module';
import {SettingsModule} from '@app/modules/settings/settings.module';
import {ComboProductsModule} from '@app/modules/combo-products/combo-products.module';
import {TempSaleModule} from '@app/modules/temp-sale/temp-sale.module';
import {PricingListModule} from '@app/modules/pricing-list/pricing-list.module';
import {CreditNoteModule} from '@app/modules/credit-note/credit-note.modules'
import {PaymentComponent} from '@app/pages/payment/payment.component';
import {ReceiptsComponent} from "@app/pages/receipts/receipts.component";
import {SoaComponent} from "@app/pages/soa/soa.component";
import {SoaPaymentComponent} from "@app/pages/soa-payment/soa-payment.component";

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {path: '', redirectTo: 'dashboards', pathMatch: 'prefix'},
      {
        path: 'dashboards',
        loadComponent: () => DashboardsComponent,
        canActivate: [AuthGuard],
        data: {level: 1, path: '/dashboards'}
      },
      {
        path: 'medicine',
        loadComponent: () => MedicineComponent,
        canActivate: [AuthGuard],
        data: {level: 1, path: '/medicine'}
      },
      {
        path: 'vendor',
        loadComponent: () => VendorComponent,
        canActivate: [AuthGuard],
        data: {level: 1, path: '/vendor'}
      },
      {
        path: 'customer',
        loadComponent: () => CustomerComponent,
        canActivate: [AuthGuard],
        data: {level: 1, path: '/customer'}
      },

      {
        path: 'purchase-order',
        loadChildren: () => PurchaseOrderModule,
        canActivate: [AuthGuard],
        data: {level: 1, path: '/purchase-order'}
      },
      {
        path: 'purchase',
        loadChildren: () => PurchaseModule,
        canActivate: [AuthGuard],
        data: {level: 1, path: '/purchase'}
      },
      {path: 'sale', loadChildren: () => SaleModule, canActivate: [AuthGuard], data: {level: 1, path: '/sale'}},
      {
        path: 'pricing-plan',
        loadComponent: () => PricingPlanComponent,
        canActivate: [AuthGuard],
        data: {level: 1, path: '/pricing-plan'}
      },
      {path: 'notes', loadComponent: () => NotesComponent, canActivate: [AuthGuard], data: {level: 1, path: '/notes'}},

      {path: 'report', loadChildren: () => ReportModule, canActivate: [AuthGuard], data: {level: 1, path: '/report'}},
      {
        path: 'pricing-list',
        loadChildren: () => PricingListModule,
        canActivate: [AuthGuard],
        data: {level: 1, path: '/pricing-list'}
      },
      {
        path: 'combo-products',
        loadChildren: () => ComboProductsModule,
        canActivate: [AuthGuard],
        data: {level: 1, path: '/combo-products'}
      },
      {
        path: 'temp-sale',
        loadChildren: () => TempSaleModule,
        canActivate: [AuthGuard],
        data: {level: 1, path: '/temp-sale'}
      },
      {
        path: 'settings',
        loadChildren: () => SettingsModule,
        canActivate: [AuthGuard],
        data: {level: 1, path: '/settings'}
      },
      {
        path: 'credit-note',
        loadChildren: () => CreditNoteModule,
        canActivate: [AuthGuard],
        data: {level: 1, path: '/credit-note'}
      },
      {
        path: 'payment', 
        loadComponent: () => PaymentComponent, 
        canActivate: [AuthGuard], 
        data: {level: 1, path: '/payment'}
      },
      {
        path: 'receipts',
        loadComponent: () => ReceiptsComponent,
        canActivate: [AuthGuard],
        data: {level: 1, path: '/receipts'}
      },
      {
        path: 'soa',
        loadComponent: () => SoaComponent,
        canActivate: [AuthGuard],
        data: {level: 1, path: '/soa'}
      },
      {
        path: 'soa-payment',
        loadComponent: () => SoaPaymentComponent,
        canActivate: [AuthGuard],
        data: {level: 1, path: '/soa-payment'}
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LayoutRoutingModule {
}
